import { Flex, Text } from "rebass";
import styled from "styled-components";
import { BiMessageDetail } from "react-icons/bi";

import { IUserProfile } from "MVVM/@types";

interface DirectMessageContentProps {
  onClose: () => void;
  user: IUserProfile;
}

export const DirectMessageContent = ({
  onClose,
  user,
}: DirectMessageContentProps) => {
  const displayName = user.username || "this player";

  return (
    <Container>
      <IconCircle>
        <BiMessageDetail size={32} />
      </IconCircle>
      <Text variant="text.h3" color="white" mb={2}>
        Direct Messages
      </Text>
      <Subtitle>
        Soon you'll be able to message {displayName} directly — connect
        privately, recruit for your team, and talk shop without the noise.
      </Subtitle>
      <ComingSoonPill>Coming Soon</ComingSoonPill>
      <PrimaryButton onClick={onClose}>Got it</PrimaryButton>
    </Container>
  );
};

const Container = styled(Flex)`
  align-items: center;
  background: ${({ theme }) => theme.colors.ned};
  border-radius: 12px;
  flex-direction: column;
  max-width: 420px;
  padding: 32px 24px;
  text-align: center;
  width: 100%;
`;

const IconCircle = styled(Flex)`
  align-items: center;
  background: ${({ theme }) => theme.colors.navy50};
  border-radius: 50%;
  color: ${({ theme }) => theme.colors.envy};
  height: 64px;
  justify-content: center;
  margin-bottom: 16px;
  width: 64px;
`;

const Subtitle = styled(Text)`
  color: ${({ theme }) => theme.colors.ice};
  font-family: Barlow;
  font-size: 15px;
  line-height: 1.5;
  margin-bottom: 20px;
`;

const ComingSoonPill = styled.span`
  background: ${({ theme }) => theme.colors.navy50};
  border-radius: 99px;
  color: ${({ theme }) => theme.colors.envy};
  font-family: Barlow;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.5px;
  margin-bottom: 24px;
  padding: 6px 14px;
  text-transform: uppercase;
`;

const PrimaryButton = styled.button`
  align-items: center;
  background: ${({ theme }) => theme.colors.envy};
  border: none;
  border-radius: 8px;
  color: white;
  cursor: pointer;
  display: flex;
  font-family: Barlow;
  font-size: 14px;
  font-weight: 500;
  height: 36px;
  justify-content: center;
  min-width: 140px;
  white-space: nowrap;

  &:hover {
    background: ${({ theme }) => theme.colors.darkerEnvy};
  }
`;
